module.exports = __webpack_public_path__ + "img/viagem-europa.6d5643ad.png";